export const css = {
	oneaction: '_1uWQ9LaQ',
	' _key': 'ascm-theme/ascm/quiz-widgets/flashcard'
};

export default css;
